let version = require('../../package.json').version

export const environment = {
  production: true,
  envName: 'prod',
  traaqrUser: 'madison@traaqr.com',
  traaqrPassword: 'hummus12',
  gitCommit: 'b406d89c010f444ca84e3c70c95b2f1b5c801bbd',
  buildNumber: '460',
  release: version,
  driveDeveloperKey: 'AIzaSyBFWsx5cy-GlRx8hC8jiOmuGnPbZuforws',
  stripe_pk: 'pk_live_MZFAy1dQqWDafQ8TECZLn84D',
  schedulesBucket: 'veil-schedules-prod'
};
